import { setUserId, setUserProperties } from './client';
import { ENVIRONMENT } from './client';

interface EmployeeUser {
  id?: string | number;
  employeeName?: string;
  role?: string;
  permissions?: string[];
  chainId?: string | null;
  placeId?: string | null;
  retailerId?: string | null;
}

/**
 * Tags the analytics session with the logged-in employee. Called from
 * authProvider on login + on app boot when a token already exists.
 *
 * Never sends name, email or document — only the id and segmentation props.
 */
export const identifyUser = async (user: EmployeeUser): Promise<void> => {
  if (!user?.id) return;
  await setUserId(String(user.id));
  await setUserProperties({
    role: user.role ?? 'unknown',
    chain_id: user.chainId ?? 'none',
    place_id: user.placeId ?? 'none',
    retailer_id: user.retailerId ?? 'none',
    permissions_count: user.permissions?.length ?? 0,
    environment: ENVIRONMENT,
  });
};

export const clearIdentity = async (): Promise<void> => {
  await setUserId(null);
};
